export default __webpack_public_path__ + "static/media/background_login_tourist.963fbbef.svg";